<template>
  <CFooter>
    <div>
    </div>
    <div class="ml-auto">
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
